module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/folder-upload.415f83ae.svg";